const insuranceInfoResources = {
    linkLegalContract: 'Legal Contract'
};
export default insuranceInfoResources;